/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
// ==============================================
// ==================Import======================
// ==============================================
// ===================Dependancies================
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

// =================react_leaflet=================
import { CircleMarker, Marker, Popup } from 'react-leaflet';
import Leaflet from 'leaflet';

// ==================Style&IMG===================
import './style.scss';
import iconUrl from '../../../../assets/images/black.png';
import { toggleSelectedMarker } from '../../../../actions/site';

// ==================Icons=========================

function Markers({
  shortName, longName, lon, lat, alt, installDate,
  endDate = '', country, network,
}) {
  // ==================HOOK=========================
  const dataAPI = useSelector((state) => state.dataAPI.stations.list);
  const selected = useSelector(
    (state) => state.site.selectedMarkers.includes(longName),
  );
  const dispatch = useDispatch();
  const newicon = new Leaflet.Icon({
    iconUrl,
    iconSize: [13, 13],
    iconAnchor: [13, 13],
    popupAnchor: [-6.5, -13],
  });

  const highlightedIcon = new Leaflet.Icon({
    iconSize: [20, 20],
    iconAnchor: [10, 20],
    popupAnchor: [-5, -20],
  });

  const handleClick = () => dispatch(toggleSelectedMarker(longName));
  const events = { click: handleClick }; // React‑Leaflet v3
  // function to create popup for single or multiple station, that be insert in JSX
  // eslint-disable-next-line consistent-return,
  function createPopup() {
    let multipleDataPopup = false;
    for (let i = 0; i < dataAPI.data.length; i += 1) {
      if (dataAPI.data[i].location.coordinates.lat === lat
          && dataAPI.data[i].location.coordinates.lon === lon) {
        if (dataAPI.data[i].marker !== shortName) {
          multipleDataPopup = true;
        }
        if (!multipleDataPopup) {
          return (
            <Popup key={longName}>
              <div className="popup-single-station">
                <div className="station-1">
                  <ul>
                    <li><strong>Marker:</strong> {longName}</li>
                    <li><strong>Lat:</strong> {lat}</li>
                    <li><strong>Lon:</strong> {lon}</li>
                    <li><strong>Alt:</strong> {alt}</li>
                    <li><strong>Install date:</strong> {installDate}</li>
                    <li><strong>End date:</strong> {endDate}</li>
                    <li><strong>Country:</strong> {country}</li>
                    <li><strong>Network:</strong> {network}</li>
                    <li><Link to={`/metadata/marker=${longName}/description`} target="_blank">Metadata details</Link></li>
                  </ul>
                </div>
              </div>
            </Popup>
          );
        }
        return (
          <Popup key={longName}>
            <div className="popup-multiple-station">
              <div className="station-1">
                <ul>
                  <li><strong>Marker:</strong> {longName}</li>
                  <li><strong>Lat:</strong> {lat}</li>
                  <li><strong>Lon:</strong> {lon}</li>
                  <li><strong>Alt:</strong> {alt}</li>
                  <li><strong>Install date:</strong> {installDate}</li>
                  <li><strong>End date:</strong> {endDate}</li>
                  <li><strong>Country:</strong> {country}</li>
                  <li><strong>Network:</strong> {network}</li>
                  <li><Link to={`/metadata/marker=${longName}/description`} target="_blank">Metadata details</Link></li>
                </ul>
              </div>
              <div className="station-2">
                <ul>
                  <li><strong>Marker:</strong> {dataAPI.data[i].marker_long_name}</li>
                  <li><strong>Lat:</strong> {dataAPI.data[i].location.coordinates.lat}</li>
                  <li><strong>Lon:</strong> {dataAPI.data[i].location.coordinates.lon}</li>
                  <li><strong>Alt:</strong> {dataAPI.data[i].location.coordinates.altitude}</li>
                  <li><strong>Install date:</strong> {dataAPI.data[i].date_from}</li>
                  <li><strong>End date:</strong> {dataAPI.data[i].date_to}</li>
                  <li><strong>Country:</strong> {dataAPI.data[i].location.country.name}</li>
                  <li><strong>Network:</strong> {dataAPI.data[i].network.name}</li>
                  <li><Link to={`/metadata/marker=${dataAPI.data[i].marker_long_name}/description`} target="_blank">Metadata details</Link></li>
                </ul>
              </div>
            </div>
          </Popup>
        );
      }
    }
  }
  return (
    <>
      {(endDate === null)
      && (
      <CircleMarker
        key={longName}
        className={network}
        marker_long_name={longName}
        endDate={endDate}
        center={{ lat, lon }}
        radius={selected ? 12 : 5}
        eventHandlers={events}
      >
        {createPopup()}
      </CircleMarker>
      )}
      {(endDate !== null)
      && (
      <Marker
        key={longName}
        position={{ lat, lon }}
        radius={selected ? 12 : 5}
        icon={newicon}
        eventHandlers={events}
      >
        {createPopup()}
      </Marker>
      )}
    </>
  );
}

Markers.propTypes = {
  shortName: PropTypes.string.isRequired,
  longName: PropTypes.string.isRequired,
  lon: PropTypes.number.isRequired,
  lat: PropTypes.number.isRequired,
  alt: PropTypes.number.isRequired,
  installDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  country: PropTypes.string.isRequired,
  network: PropTypes.string.isRequired,

};
export default Markers;
